/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sch_Err_Status_In_UseInputs */

const en_sch_err_status_in_use = /** @type {(inputs: Sch_Err_Status_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items are still in this status. Delete it and choose where they go.`)
};

const de_sch_err_status_in_use = /** @type {(inputs: Sch_Err_Status_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es liegen noch Vorgänge in diesem Status. Lösche ihn und wähle, wohin sie wandern.`)
};

/**
* | output |
* | --- |
* | "Items are still in this status. Delete it and choose where they go." |
*
* @param {Sch_Err_Status_In_UseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sch_err_status_in_use = /** @type {((inputs?: Sch_Err_Status_In_UseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sch_Err_Status_In_UseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sch_err_status_in_use(inputs)
	return en_sch_err_status_in_use(inputs)
});